
const generateUUID = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback for older browsers
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

const getOrCreateId = (key) => {
    let id = localStorage.getItem(key);

    if (!id) {
        id = generateUUID();
        localStorage.setItem(key, id);
    }

    return id;
};

export const getUserId = () => getOrCreateId("user_id");